/* ============================================================
   Cliente de API — wrapper fino sobre fetch para falar com o
   backend Laravel (douronostrum-api).
   ============================================================ */

const BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export class ApiError extends Error {
  constructor(message, { status, code, fields, retryAfter } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.fields = fields || {};
    this.retryAfter = retryAfter;
  }
}

async function request(path, options = {}) {
  let response;
  try {
    response = await fetch(`${BASE_URL}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...options.headers,
      },
    });
  } catch (e) {
    throw new ApiError('Não foi possível ligar ao servidor.', { status: 0, code: 'network_error' });
  }

  const isJson = response.headers.get('content-type')?.includes('application/json');
  const body = isJson ? await response.json().catch(() => null) : null;

  if (!response.ok) {
    throw new ApiError(body?.message || body?.error || 'Ocorreu um erro.', {
      status: response.status,
      code: body?.error,
      fields: body?.fields,
      retryAfter: body?.retryAfter,
    });
  }

  return body;
}

function toQueryString(params) {
  if (!params) return '';
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '');
  if (entries.length === 0) return '';
  return `?${new URLSearchParams(entries).toString()}`;
}

export const api = {
  getWines: (params) => request(`/wines${toQueryString(params)}`),
  getWine: (id) => request(`/wines/${id}`),
  getWineTypes: () => request('/wines/types'),
  createOrder: (payload) => request('/orders', { method: 'POST', body: JSON.stringify(payload) }),
  sendContact: (payload) => request('/contact', { method: 'POST', body: JSON.stringify(payload) }),
  validateDiscountCode: (code, subtotal, shipping) =>
    request('/discount-codes/validate', { method: 'POST', body: JSON.stringify({ code, subtotal, shipping }) }),
  getShippingRates: () => request('/shipping-rates'),
};
